import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
});

/**
 * MySpaceMyCardsRefreshEvent
 *
 * - Evento emitido quando a abas do meu espaço precisa ser atualizada
 * - Isso pode ocorrer quando: Ele deixa de ser responsável por um card,
 *   ou quando o card é arquivado.
 */
export class MySpaceMyCardsRefreshEvent extends CreateCommand(
  RealtimeEventType.MySpaceMyCardsRefresh,
  SCHEMA,
) {}
